<template>

      <!--
    <select v-model="streamList.selected" :disabled="stream">
      <option v-for="option in streamList.options" :key="option.id" :value="option.id">
        {{ option.description }}
      </option>
    </select>
          <v-btn :disabled="stream" @click="start">
    Start
    </v-btn>


    <button :disabled="!stream" @click="stop">
    Stop
    </button> -->
    <video v-if="stream" autoplay :srcObject.prop="stream" style="width:100%;"></video>
    <!--
    <div v-if="!stream">
    No video
    </div>
    <div v-if="status">
    Status: {{ status }}
    </div>
    <div v-if="error">
    {{ error }}
    </div> -->
</template>

<script>
import { Janus } from 'janus-gateway'

const JANUS_URL = 'https://de-vs1.droneexpress.ai/janus'

export default {
  props: {
    streamId: Number
  },
  components: {
  },
  data() {
    return {
      janus: null,
      plugin: null,
      stream: null,
      error: null,
      status: null,
      currentStreamId: 99,
      streamList: {
        selected: null,
        options: []
      }
    }
  },
  mounted() {
    Janus.init({
      debug: true,
      dependencies: Janus.useDefaultDependencies(),
      callback: () => {
        this.connect(JANUS_URL)
      }
    })
  },
  destroyed() {
      this.stop()
  },
  watch: {
    streamId: function() {
      console.log('streamname changed! '+this.streamId)
      if (this.streamId !== this.currentStreamId) {
        // this.stop()
        // this.streamList.selected = streamId;
        // this.start()
        this.currentStreamId = this.streamId
        // this.plugin.send({ message: { request: "stop" } })
        this.plugin.send({ message: { request: "switch", id: this.streamId } })
      } 
    }
  },
  methods: {
    connect(server) {
      this.janus = new Janus({
        server,
        success: () => {
          this.attachPlugin()
        },
        error: (error) => {
          this.onError('Failed to connect to janus server', error)
        },
        /* destroyed: () => {
          window.location.reload()
        } */
      })
    },
    attachPlugin() {
      this.janus.attach({
        plugin: "janus.plugin.streaming",
        opaqueId: 'thisisopaqueid',
        success: (plugin) => {
          this.plugin = plugin
          this.updateStreamsList()
        },
        error: (error) => {
          this.onError('Error attaching plugin... ', error)
        },
        onmessage: (msg, jsep) => {
          if (msg && msg.result) {
            const result = msg.result
            if (result.status) {
              this.status = result.status
            }
          } else if (msg && msg.error) {
            this.onError(msg.error)
          }
          if (jsep) {
            let stereo = (jsep.sdp.indexOf("stereo=1") !== -1);
            this.plugin.createAnswer({
              jsep: jsep,
              media: { audioSend: false, videoSend: false },
              customizeSdp: (jsep) => {
                if (stereo && jsep.sdp.indexOf("stereo=1") === -1) {
                  jsep.sdp = jsep.sdp.replace("useinbandfec=1", "useinbandfec=1;stereo=1");
                }
              },
              success: (jsep) => {
                var body = { request: "start" };
                this.plugin.send({ message: body, jsep: jsep });
              },
              error: (error) => {
                this.onError("WebRTC error:", error);
              }
            })
          }
        },
        onremotestream: (stream) => {
          this.onRemoteStream(stream)
        },
        oncleanup: () => {
          this.onCleanup()
        }
      })
    },
    updateStreamsList() {
      this.plugin.send({
        message: { request: 'list' },
        success: (result) => {
          if (!result) {
            this.onError("Got no response to our query for available streams")
          }
          this.streamList.options = result.list
          if (result.list.length) {
            this.streamList.selected = this.streamList.options[0].id
          }
          this.start()
        }
      })
    },
    start() {
      this.plugin.send({ message: { request: "watch", id: this.streamId } })
    },
    stop() {
      this.plugin.send({ message: { request: "stop" } })
      this.plugin.hangup()
      this.onCleanup()
    },
    onRemoteStream(stream) {
      if (stream.active) {
        this.stream = stream
      } else {
        this.stream = null
      }
    },
    onCleanup() {
      console.log('onCleanup')
      this.stream = null
      this.status = null
      this.error = null
      this.janus = null
      this.plugin = null
    },
    onError(message, error='') {
      Janus.error(message, error)
      this.error = message + error
    }
  }
}
</script>
